import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const GloryIcon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/$GLORY.png" style={style} />
}
